import { RadioGroup } from "@Light/components/system/RadioGroup";
import type { Utility } from "@Light/services/lightTypes";

export type UtilityRadioGroupProps = {
  name: string;
  utilities: Utility[];
  value?: Utility;
  onChange: (utility: Utility) => void;
  onClickProvideAddress?: () => void;
};

export const UtilityRadioGroup = ({
  name,
  utilities,
  value,
  onChange,
  onClickProvideAddress,
}: UtilityRadioGroupProps) => (
  <div className="flex flex-col gap-3">
    <RadioGroup
      name={name}
      options={utilities.map((utility) => ({
        value: utility,
        label: utility.full_name,
      }))}
      value={value}
      onChange={onChange}
    />
    {onClickProvideAddress ? (
      <button
        type="button"
        onClick={onClickProvideAddress}
        data-testid="zip-utility-provide-address"
        className="cursor-pointer text-center text-sm text-tertiary underline underline-offset-4"
      >
        Provide your address instead
      </button>
    ) : null}
  </div>
);
